import { render, staticRenderFns } from "./land2.vue?vue&type=template&id=0c3f7f00&scoped=true"
import script from "./land2.vue?vue&type=script&lang=js"
export * from "./land2.vue?vue&type=script&lang=js"
import style0 from "./land2.vue?vue&type=style&index=0&id=0c3f7f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3f7f00",
  null
  
)

export default component.exports